export const OVERVIEW_PATH = '/delivery-notes';
export const OVERVIEW_FINISHED_PATH = '/delivery-notes/finished';
export const OVERVIEW_TESTING_PATH = '/delivery-notes/testing';

export const CHANNEL_PATH = '/delivery-notes/channels/:channelId';
export const CHANNEL_FINISHED_PATH = '/delivery-notes/channels/:channelId/finished';
export const CHANNEL_TESTING_PATH = '/delivery-notes/channels/:channelId/testing';
export const CHANNEL_CONFIG_PATH = '/delivery-notes/channels/:channelId/config/:tab?/:configId?';
export const CHANNEL_MASTERDATA_PATH = '/delivery-notes/channels/:channelId/masterdata';

export const ASSISTANCE_PATH = '/delivery-notes/:recordId';
export const ASSISTANCE_TAB_PATH = '/delivery-notes/:recordId/:tab';
